import { ServiceRequest } from "../../api/ServiceRequest";

export class RoleRequest extends ServiceRequest {
  private roleName?: string;
  private permission?: number;

  constructor(init?: Partial<RoleRequest>) {
    super(init);
    Object.assign(this, init);
  }

  // ✅ Getters
  getRoleName(): string | undefined {
    return this.roleName;
  }

  getPermission(): number | undefined {
    return this.permission;
  }

  // ✅ Setters
  setRoleName(value: string | undefined): void {
    this.roleName = value;
  }

  setPermission(value: number | undefined): void {
    this.permission = value;
  }
}
